import React, { useState, useEffect } from 'react'
import { Layout, Row, Col, Card, Button, Input, Grid } from 'antd'
import axios from 'axios'
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaBirthdayCake,
  FaTint,
  FaGraduationCap,
  FaBriefcase,
  FaCalendarAlt,
  FaAward,
} from 'react-icons/fa'
import Newscard from './Newscard'
import {
  EventAluminiFindOne,
  EventAluminiHomeUpdate,
  ImagePath,
} from '../../ApiFile'
import Sidebar from './sidebar'
import Header from './Header'
import { useNavigate } from 'react-router-dom'
import MobileNavbarAlumini from './MobileNavbarAlumini'

const { Content } = Layout
const { useBreakpoint } = Grid

function HomeAlumini() {

  const navigate = useNavigate()
  const [openSidebarToggle, setOpenSidebarToggle] = useState(false)
  const [alumniData, setAlumniData] = useState({})
  const [editableFields, setEditableFields] = useState({})
  const [isEditMode, setIsEditMode] = useState(false)
  const userdata = JSON.parse(sessionStorage.getItem('userdata'))
  const id = userdata.id
   const year = sessionStorage.getItem('currentYear')

  useEffect(() => {
    const fetchAlumniData = async () => {
      try {
        const response = await axios.get(`${EventAluminiFindOne}/${id}`)
        setAlumniData(response.data[0])
        setEditableFields(response.data[0])
      } catch (error) {
        console.error('Error fetching alumni data:', error)
      }
    }

    fetchAlumniData()
  }, [id])

  const handleInputChange = (e) => {
    const { name, value } = e.target
    setEditableFields({ ...editableFields, [name]: value })
  }

  const toggleEditMode = () => {
    setIsEditMode(!isEditMode)
  }

  const handleEditProfile = () => {
    navigate('/EditAluminiProfile')
  }

  const updateAlumniData = async () => {
    try {
      await axios.put(
        `${EventAluminiHomeUpdate}/${alumniData.id}`,
        editableFields,
      )
      alert('Update successful!')
      setIsEditMode(false)
      setAlumniData(editableFields)
    } catch (error) {
      console.error('Error updating alumni data:', error)
      alert('Update failed!')
    }
  }

  return (
    <Layout>
      <div className="roomchange-container" style={{ display: 'flex', minHeight: '100vh' }}>
      {/* Sidebar on the left for desktop */}
      <div className="d-none d-md-block sidebar-container" style={{ width: '270px', flexShrink: 0, }}>
        <Sidebar />
      </div>

      {/* Main content on the right */}
      <div className="main-content flex-grow-1" style={{ flex: 1, backgroundColor: '#f8f9fa'}}>
        <Header />
                     
                           <div className="d-block d-md-none">
                             <MobileNavbarAlumini />
                           </div>

        <Content>
          <div
            className="site-layout-background"
            style={{ padding: 24, minHeight: 360 }}
          >
            <Row gutter={[16, 16]}>
              <Col span={24}>
                 <h5 className="room-change-title text-start mt-md-4 mt-2" style={{ color: '#0783d6' }}>
                  DASHBOARD
            </h5>
              </Col>
              <Col xs={24} md={16} >
                <Card className='shadow rounded'
                  title={
                    <div style={{ display: 'flex', alignItems: 'center', }}>
                      <img
                        src={`${ImagePath}/${alumniData.profile_img}`}
                        alt="Profile"
                        className="me-5"
                        style={{ width: 70, height: 70 }}
                      />
                      {isEditMode ? (
                        <Row gutter={8} style={{ width: '100%' }}>
                          <Col span={8}>
                            <Input
                              type="text"
                              name="f_name"
                              value={editableFields.f_name}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col span={8}>
                            <Input
                              type="text"
                              name="m_name"
                              value={editableFields.m_name}
                              onChange={handleInputChange}
                            />
                          </Col>
                          <Col span={8}>
                            <Input
                              type="text"
                              name="l_name"
                              value={editableFields.l_name}
                              onChange={handleInputChange}
                            />
                          </Col>
                        </Row>
                      ) : (
                        `${alumniData.f_name} ${alumniData.m_name} ${alumniData.l_name}`
                      )}
                    </div>
                  }               
                  // bordered={false}
                >
                  <Row gutter={[16, 16]} >
                    <Col xs={24} md={12}>
                      <p>
                        <FaEnvelope style={{ color: 'blue' }} /> <b>Email:</b>{' '}
                        {alumniData.email_id}
                      </p>
                      <p>
                        <FaPhone style={{ color: 'blue' }} /> <b>Contact No:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="mob_no"
                            value={editableFields.mob_no}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.mob_no
                        )}
                      </p>
                      <p>
                        <FaMapMarkerAlt style={{ color: 'blue' }} />{' '}
                        <b>Current Address:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="current_address"
                            value={editableFields.current_address}
                            onChange={handleInputChange}
                          />
                        ) : (
                          `${alumniData.current_address}, ${alumniData.taluka}, ${alumniData.district}, ${alumniData.state}, ${alumniData.pincode}`
                        )}
                      </p>
                    </Col>
                    <Col xs={24} md={12}>
                      <p>
                        <FaPhone style={{ color: 'blue' }} />{' '}
                        <b>Alternate Contact No:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="alternate_mobno"
                            value={editableFields.alternate_mobno}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.alternate_mobno
                        )}
                      </p>
                      <p>
                        <FaMapMarkerAlt style={{ color: 'blue' }} />{' '}
                        <b>Permanent Address:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="alternate_address"
                            value={editableFields.alternate_address}
                            onChange={handleInputChange}
                          />
                        ) : (
                          `${alumniData.alternate_address}, ${alumniData.alternate_taluka}, ${alumniData.alternate_district}, ${alumniData.alternate_state}, ${alumniData.alternate_pincode}`
                        )}
                      </p>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} >
                    <Col xs={24} md={12}>
                      <p>
                        <FaBirthdayCake style={{ color: 'blue' }} />{' '}
                        <b>Date of Birth:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="dateofbirth"
                            value={editableFields.dateofbirth}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.dateofbirth
                        )}
                      </p>
                      <p>
                        <FaGraduationCap style={{ color: 'blue' }} />{' '}
                        <b>Qualification:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="qualification"
                            value={editableFields.qualification}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.qualification
                        )}
                      </p>
                    </Col>
                    <Col xs={24} md={12}>
                      <p>
                        <FaTint style={{ color: 'blue' }} /> <b>Blood Group:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="blood_group"
                            value={editableFields.blood_group}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.blood_group
                        )}
                      </p>
                      <p>
                        <FaBriefcase style={{ color: 'blue' }} />{' '}
                        <b>Professional Category:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="professional_category"
                            value={editableFields.professional_category}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.professional_category
                        )}
                      </p>
                    </Col>
                  </Row>

                  <Row gutter={[16, 16]} >
                    <Col xs={24} md={12}>
                      <p>
                        <FaBriefcase style={{ color: 'blue' }} />{' '}
                        <b>Service/Business Name:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="business_service_name"
                            value={editableFields.business_service_name}
                            onChange={handleInputChange}
                          />
                        ) : (
                          alumniData.business_service_name
                        )}
                      </p>
                    </Col>
                    <Col xs={24} md={12}>
                      <p>
                        <FaCalendarAlt style={{ color: 'blue' }} />{' '}
                        <b>Year Of Residence:</b>{' '}
                        {isEditMode ? (
                          <Input
                            type="text"
                            name="fromyearof_boarding"
                            value={editableFields.fromyearof_boarding}
                            onChange={handleInputChange}
                          />
                        ) : (
                          `${alumniData.fromyearof_boarding}-${alumniData.toyearof_boarding}`
                        )}
                      </p>
                    </Col>
                  </Row>

                  <p>
                    <FaAward style={{ color: 'blue' }} />{' '}
                    <b>Achievements if Any:</b>{' '}
                    {isEditMode ? (
                      <Input
                        type="text"
                        name="achievements"
                        value={editableFields.achievements}
                        onChange={handleInputChange}
                      />
                    ) : (
                      alumniData.achievements
                    )}
                  </p>
                </Card>

                <Row gutter={[16, 16]} className='mt-3'>
                  <Col span={24}  className='m-1'>
                    <Button style={{backgroundColor:"black",color:"white"}} onClick={handleEditProfile}>Edit Profile</Button>
                  </Col>
                </Row>

              </Col>

              <Col xs={24} md={8} >
                <Newscard />
              </Col>
            </Row>



          </div>
        </Content>
      </div>
      </div>
    </Layout>
  )
}

export default HomeAlumini
